import  { useEffect, useState } from "react";
import { Input, Form, Button } from "antd";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import "../ev-home-page.css";
import bannerBG from "../../../assets/img/bannerBG.png";
import Ripples from "react-ripples";
import _ from "lodash";
import { isEmpty } from "lodash";
import { useActions } from "../../../core-units/hooks/useActions";
import { useSelector } from "react-redux";

const Locations = (props) => {
  const { auth, servicesList, distance } = useActions();
  const authState = useSelector((state) => state.auth);
  const { routingValidation } = props;
  const homeLocation = "Ste 975/585 Little Collins St, Melbourne VIC 3000, Australia";
  const [selectedEvValuelocation, setSelectedEvValuelocation] = useState("");
  const [locSearchEvData, setLocSearchEvData] = useState([]);
  const [evFetching, setEvFetching] = useState(false);
  const [evLocDiff, setEvLocDiff] = useState(0);
  const [lastLoginAttempt, setLastLoginAttempt] = useState(0);
  const [loginRetryCount, setLoginRetryCount] = useState(0);

   const parseLocationData = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch (error) {
      // ignore invalid JSON
    }
    if (typeof value === "string" && value.includes(",")) {
      return value.split(",").map((item) => Number(item.trim()));
    }
    return [];
  };

   const handleLogin = () => {
    if (loginInProgress) {
      return;
    }

    // Prevent retry storm: wait at least 3 seconds between attempts
    const now = Date.now();
    const timeSinceLastAttempt = now - lastLoginAttempt;
    const minRetryDelay = 3000;

    if (timeSinceLastAttempt < minRetryDelay) {
      return;
    }

    // Max 5 retry attempts to prevent infinite loops
    if (loginRetryCount > 5) {
      console.error(
        "[EV-Location] Login retry limit exceeded. Check backend auth endpoint."
      );
      return;
    }

    setLastLoginAttempt(now);
    setLoginRetryCount((prev) => prev + 1);

    const request = {};
    auth(request, () => {
      setLoginRetryCount(0); // Reset on success
      servicesList();
    });
  };

  const authLoggedInValue = _.get(authState, "signupDetails.isLoggedIn", false);
  const loginInProgress = _.get(authState, "inProgress", false);
  const storedLoginStatus = localStorage.getItem("safebuyLoggedInStatus");
  const isLoggedIn =
    authLoggedInValue === true ||
    authLoggedInValue === "true" ||
    storedLoginStatus === "true";
  
  // ------------------ INITIAL LOAD ------------------
  useEffect(() => {
    setEvLocDiff(localStorage.getItem("evDiffLoc"));
    setLocSearchEvData(
        parseLocationData(localStorage.getItem("locSearchEvData"))
);
    setSelectedEvValuelocation(localStorage.getItem("selectedEvValuelocation"));
  }, []);

  // Separate effect for auth check with retry logic
  useEffect(() => {
    if (!isLoggedIn && !loginInProgress) {
      handleLogin();
    }
  }, [isLoggedIn, loginInProgress, lastLoginAttempt]);

  // ------------------ LOCATION CHANGE ------------------
  const handleChange = (address) => {
    setSelectedEvValuelocation(address);
  };

  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        locationDifference(latLng);
        setSelectedEvValuelocation(address);
      })
      .catch((error) => console.error("Error", error));
  };

  const locationDifference = (latLng) => {
    const latLngD = [latLng.lat, latLng.lng];
    setLocSearchEvData(latLngD);
  };

  // ------------------ SUBMIT ------------------
  const onSubmit = () => {
    if (
      !isEmpty(selectedEvValuelocation) ||
      !_.isEmpty(localStorage.getItem("selectedEvValuelocation"))
    ) {
      localStorage.removeItem("evValue");
      localStorage.removeItem("evService");
      localStorage.removeItem("evTotal");
      localStorage.removeItem("evProduct");
      servicesList();

      document.getElementById("sample")?.scrollIntoView({
        behavior: "smooth",
      });

      const origin = homeLocation;
      const destination = selectedEvValuelocation;

      distance(
        {
          origin,
          destination,
          destinationAddress: selectedEvValuelocation,
          mode: "driving",
        },
        (value) => {
          console.log("Distance API response (EV):", value);
          const routes = _.get(value, "routes", []);
          let shortestDistanceKm = 0;

          if (routes.length > 0) {
            let shortestDistanceMeters = Number.MAX_SAFE_INTEGER;

            routes.forEach((route) => {
              (route.legs || []).forEach((leg) => {
                const distanceMeters = _.get(leg, "distanceMeters", _.get(leg, "distance.value", 0));
                if (distanceMeters < shortestDistanceMeters) {
                  shortestDistanceMeters = distanceMeters;
                }
              });
            });

            shortestDistanceKm = shortestDistanceMeters / 1000;
          }

          console.log("Shortest distance selected (EV):", shortestDistanceKm);
          setEvLocDiff(shortestDistanceKm);
          setEvFetching(false);
          localStorage.setItem("evDiffLoc", shortestDistanceKm);
        }
      );

      localStorage.setItem("selectedEvValuelocation", selectedEvValuelocation);
      localStorage.setItem("locationSearchEvData", locSearchEvData);
    }
  };

  // ------------------ EDIT ------------------
  const onEdit = () => {
    [
      "evValue",
      "evService",
      "evTotal",
      "evProduct",
      "selectedEvValuelocation",
      "locSearchEvData",
      "evDiffLoc",
    ].forEach((key) => localStorage.removeItem(key));

    setSelectedEvValuelocation("");
    setLocSearchEvData([]);
    setEvLocDiff(0);
    routingValidation.home();
    setEvFetching(true);
  };

  // ------------------ UI ------------------
  const searchOptions = {
    componentRestrictions: { country: "aus" },
  };

  return (
    <div
      className="EvBannerSection"
      style={{ backgroundImage: `url(${bannerBG})` }}
    >
      <div className="EvBannerTextContainer">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="EvBannerTextTitle">
                <span className="text-nowrap">Whenever you buy</span>
                <span className="txt-brown">SafeBuy</span>
              </div>

              <div className="EvBannerTextDesc">
                <b>
                  Book your inspection by entering the car location (
                  <span className="Evaddress">Complete address</span>)
                </b>
              </div>

              <div className="EvBannerInputContainer">
                <Form>
                  <Form.Item>
                    <PlacesAutocomplete
                      value={selectedEvValuelocation||""}
                      onChange={handleChange}
                      onSelect={handleSelect}
                      searchOptions={searchOptions}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div>
                          <Input
                            {...getInputProps({
                              placeholder:
                                "585 Collins Street, Melbourne, VIC 3000",
                              className: "location-search-input",
                            })}
                          />

                          {_.isEmpty(selectedEvValuelocation) && (
                            <span className="Evlocation-error-message">
                              Please fill this field!
                            </span>
                          )}

                          <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map((suggestion, index) => (
                              <div
                                key={index}
                                {...getSuggestionItemProps(suggestion)}
                              >
                                {suggestion.description}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                  </Form.Item>

                  <Form.Item>
                    <Ripples className="buttonRipple">
                      <Button
                        id="sample"
                        onClick={
                          routingValidation.route === false &&
                          _.isEmpty(
                            localStorage.getItem("selectedEvValuelocation")
                          )
                            ? onSubmit
                            : onEdit
                        }
                      >
                        {routingValidation.route === false &&
                        _.isEmpty(localStorage.getItem("selectedEvValuelocation"))
                          ? "Get Started"
                          : "Edit / Change"}
                      </Button>
                    </Ripples>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Locations;
